import { render, staticRenderFns } from "./ChoiseStudent.vue?vue&type=template&id=099fd2e4&scoped=true"
import script from "./ChoiseStudent.vue?vue&type=script&lang=js"
export * from "./ChoiseStudent.vue?vue&type=script&lang=js"
import style0 from "./ChoiseStudent.vue?vue&type=style&index=0&id=099fd2e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099fd2e4",
  null
  
)

export default component.exports